import { render } from "./Monitoring.vue?vue&type=template&id=f4e66cb6&scoped=true"
import script from "./Monitoring.vue?vue&type=script&lang=js"
export * from "./Monitoring.vue?vue&type=script&lang=js"

import "./Monitoring.vue?vue&type=style&index=0&id=f4e66cb6&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4e66cb6"]])

export default __exports__